// =============================================
// SERVICIO DE PERÍODOS
// Maneja todas las peticiones al API de períodos
// =============================================

import api from './api';

const periodService = {
  // PERÍODOS: Obtener todos los períodos
  getAll: async () => {
    const response = await api.get('/periods');
    return response.data;
  },

  // PERÍODOS: Obtener período activo
  getActive: async () => {
    const response = await api.get('/periods/active');
    return response.data;
  },

  // PERÍODOS: Obtener período por ID
  getById: async (id) => {
    const response = await api.get(`/periods/${id}`);
    return response.data;
  },

  // PERÍODOS: Obtener estadísticas de período
  getStats: async (id) => {
    const response = await api.get(`/periods/${id}/stats`);
    return response.data;
  },

  // PERÍODOS: Crear nuevo período
  create: async (periodData) => {
    const response = await api.post('/periods', periodData);
    return response.data;
  },

  // PERÍODOS: Actualizar período
  update: async (id, periodData) => {
    const response = await api.put(`/periods/${id}`, periodData);
    return response.data;
  },

  // PERÍODOS: Cerrar período
  close: async (id, closeData) => {
    const response = await api.post(`/periods/${id}/close`, closeData);
    return response.data;
  },

  // PERÍODOS: Reabrir período
  reopen: async (id) => {
    const response = await api.post(`/periods/${id}/reopen`);
    return response.data;
  },

  // PERÍODOS: Eliminar período
  delete: async (id) => {
    const response = await api.delete(`/periods/${id}`);
    return response.data;
  },
};

export default periodService;
